<template>
  <form v-if="prices" @submit.prevent="addToBasket">
    <template v-if="prices.concessions">
      <div class="concessions">
        <div
          v-for="concession in prices.concessions"
          :key="concession.id"
          class="concession"
        >
          <div class="price-description">{{ concession.description }}</div>
          <div class="price-range">{{ priceRange(concession.id) }}</div>
          <div class="quantity">
            <number-input
              v-model="concession.quantity"
              :max="quantityAvailable + concession.quantity"
            />
          </div>
        </div>
      </div>
      <button class="ui-button" type="submit">
        {{ addToBasketButtonText }}
      </button>
    </template>
  </form>
</template>
<script>
import NumberInput from '@/components/NumberInput.vue';
export default {
  components: { NumberInput },
  props: {
    product: { type: [Object], default: null },
    prices: { type: [Object], default: null },
    basketItemGroups: { type: Array, default: null },
    quantities: { type: [Object], default: null }
  },
  data: function() {
    return {
      quantitiesUpdated: false
    };
  },
  computed: {
    addToBasketButtonText() {
      return this.basketItemGroups.length > 0 ? 'Update' : 'Add';
    },
    quantityAvailable() {
      if (this.quantities.available == -1) {
        return 100; //quantity is untracked
      } else {
        var usedQuantities = 0;
        this.prices.concessions.forEach(function(concession) {
          usedQuantities = usedQuantities + concession.quantity;
        });

        return this.quantities.available - usedQuantities;
      }
    }
  },
  methods: {
    priceRange(concessionId) {
      var prices = Object.values(this.prices.prices[concessionId]);
      if (prices.length == 1) {
        return '£' + prices[0].toFixed(2);
      } else {
        return (
          '£' +
          Math.min(...prices).toFixed(2) +
          ' - £' +
          Math.max(...prices).toFixed(2)
        );
      }
    },
    addToBasket() {
      this.$emit('add-to-basket');
    }
  }
};
</script>
